import { render } from "./adminDashboard.vue?vue&type=template&id=63ef3726&scoped=true"
import script from "./adminDashboard.vue?vue&type=script&lang=js"
export * from "./adminDashboard.vue?vue&type=script&lang=js"

import "./adminDashboard.vue?vue&type=style&index=0&id=63ef3726&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ef3726"]])

export default __exports__